import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateRegistrationABTestFlow } from '~/components/authentication/ducks';
import type { AppDispatch } from '~/store/types';

enum ABTestStorageKeys {
	ENABLE_ONTARIO_ONBOARDING_FLOW_B = 'enableOnboardingFlowB'
}

const SetUpRegistrationFlowListeners = () => {
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		if (typeof window === 'undefined' || !('localStorage' in window) || window.localStorage === null) {
			return;
		}

		const initializeFromLocalStorage = () => {
			const value = localStorage.getItem(ABTestStorageKeys.ENABLE_ONTARIO_ONBOARDING_FLOW_B);
			if (value !== null) {
				dispatch(updateRegistrationABTestFlow({ isOntarioOnboardingFlowB: value === 'true' }));
			}
		};

		const handlePostMessage = (event: MessageEvent) => {
			if (event.origin !== window.location.origin) {
				return;
			}

			const { type, key, value } = (event.data as { type?: string; key?: string; value?: unknown }) || {};
			if (type === 'VWO_AB_TEST' && key === ABTestStorageKeys.ENABLE_ONTARIO_ONBOARDING_FLOW_B) {
				dispatch(updateRegistrationABTestFlow({ isOntarioOnboardingFlowB: value === 'true' }));
			}
		};

		initializeFromLocalStorage();

		window.addEventListener('message', handlePostMessage);

		return () => {
			window.removeEventListener('message', handlePostMessage);
		};
	}, [dispatch]);
};

export default SetUpRegistrationFlowListeners;
